// extracted by mini-css-extract-plugin
export var cardContainer = "_pe-0";
export var cardHeader = "_pe-2";
export var collapsedState = "_pe-3";
export var dragHandle = "_pe-5";
export var dragHandleIcon = "_pe-6";
export var dragging = "_pe-1";
export var titleArea = "_pe-4";